import amplitude from 'amplitude-js';

const VIEW_PREFIX = 'data-fdv';
const ELEMENT_PREFIX = 'data-fde';

(() => {
  if (!process.env.AMPLITUDE_API_KEY) {
    return;
  }

  amplitude.getInstance().init(process.env.AMPLITUDE_API_KEY, null, {
    // apiEndpoint: 'ap.flodesk.com',
    saveEvents: true,
    includeFbclid: true,
    includeGclid: true,
    includeUtm: true,
    includeReferrer: true,
  });

  document.addEventListener(
    'click',
    e => {
      const targetEl = e.target.closest(`[${ELEMENT_PREFIX}-name]`);
      if (!targetEl) {
        return;
      }
      const fdeAttributes = [...targetEl.attributes].filter(attribute =>
        attribute.name.startsWith(ELEMENT_PREFIX),
      );
      const fdeData = {};
      fdeAttributes.forEach(attribute => {
        const name = attribute.name.replace(`${ELEMENT_PREFIX}-`, '');
        if (name.indexOf('.') === -1) {
          fdeData[name] = attribute.value;
        } else {
          const [arrName] = name.split('.');
          fdeData[arrName] = [...(fdeData[arrName] || []), attribute.value];
        }
      });
      const { name, ...properties } = fdeData;
      amplitude.getInstance().logEvent(name, properties);
    },
    true,
  );

  const viewEl = document.querySelector(`[${VIEW_PREFIX}-name^="view:"]`);
  if (viewEl) {
    const name = viewEl.getAttribute(`${VIEW_PREFIX}-name`).replace(`${VIEW_PREFIX}-`, '');
    amplitude.getInstance().logEvent(name);
  }
})();
